import '~/index.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router'

// [OS-459] Remove polyfill once temporal support is baseline
import '~/common/temporal'
import '~/i18n'
import { routes } from '~/router/routes'

// Swap favicon by environment so local/staging/prod/alpha-prod tabs are visually distinct
const viteEnv = import.meta.env as Record<string, string | undefined>
const env = viteEnv['VITE_ENV'] ?? viteEnv['VITE_VERCEL_ENV'] ?? ''
const href = window.location.href.toLowerCase()
let faviconEnv: 'production' | 'staging' | 'local' | 'alpha-prod' = 'local'
if (env === 'production') {
  // alpha-prod runs against production env vars but lives on a distinct hostname
  faviconEnv = href.includes('alpha-prod.') ? 'alpha-prod' : 'production'
} else if (env === 'staging' || env === 'preview') {
  faviconEnv = 'staging'
}
const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
if (favicon) {
  favicon.href = `/favicons/${faviconEnv}.svg`
}

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root element #root not found in document')
}

const router = createBrowserRouter(routes)

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
